import Shape from './shape';
import './node';
import './edge';
import './combo';
import './combos';
import './nodes';
export { default as Arrow } from './arrow';
export { default as Marker } from './marker';
export default Shape;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-core/es/element/index.js
// module id = null
// module chunks = 